import {
  type RouteRecordRaw,
} from 'vue-router'

export default [
  // {
  //   name: 'Products',
  //   path: '/products',
  //   redirect: '/products/sign',
  //   meta: {
  //     title: '产品中心',
  //     order: 3,
  //   },
  //   component: DefaultLayout,
  //   children: [{
  //     path: 'sign',
  //     name: 'ProductsSign',
  //     component: () => import('@/views/empty.vue'),
  //     meta: {
  //       title: '产品签约(未提供)',
  //       isTopLevel: true,
  //       icon: 'icon-shenpi',
  //     },
  //   }, {
  //     path: 'config',
  //     name: 'ProductsConfig',
  //     component: () => import('@/views/empty.vue'),
  //     meta: {
  //       title: '产品配置(未提供)',
  //       isTopLevel: true,
  //       icon: 'icon-peizhi',
  //     },
  //   }, {
  //     path: 'payment',
  //     name: 'ProductsPayment',
  //     meta: {
  //       title: '支付产品',
  //       icon: 'icon-chanpin',
  //     },
  //     children: [{
  //       path: 'code',
  //       name: 'ProductsPaymentCode',
  //       component: () => import('@/views/empty.vue'),
  //       meta: {
  //         title: '聚合收款码(未提供)',
  //       },
  //     }],
  //   }],
  // },
] as Array<RouteRecordRaw>
